import React from 'react';
import { Dialog, Divider } from '@material-ui/core';
import { injectIntl } from 'react-intl';

function RemoveDialog({
  open,
  onClose,
  intl,
  onConfirm,
  onCancel,
  message,
  title = 'ACTIONS.REMOVE.TITLE',
  deleteButton = 'DELETE',
  name,
}) {
  const HEIGHT = 26;

  return (
    <Dialog onClose={onClose} open={open}>
      <div style={{ minWidth: '500px' }}>
        <div className="col-12 px-4 card-header" style={{ fontWeight: 800 }}>
          <span>{intl.formatMessage({ id: title })}</span>
        </div>
        <div className="col-12 py-2 px-4 card-body" style={{ minHeight: 80 }}>
          <span>{intl.formatMessage({ id: message })}</span>
          {name ? (
            <span className="font-weight-bolder ml-1">
              {intl.formatMessage({ id: 'NAME_VALUE' }, { name })}.
            </span>
          ) : null}
          <p className="attention">
            {intl.formatMessage({ id: 'ACTIONS.CANNOT_REVERT' })}
          </p>
        </div>
        <Divider />
        <div
          className="col-12 px-4 d-flex justify-content-end my-2"
          style={{ padding: '0px !important' }}
        >
          <button
            onClick={onConfirm}
            type="button"
            className="btn btn-bordered danger-bg d-flex align-items-center"
            style={{ color: '#FFFFFF', height: HEIGHT }}
          >
            {intl.formatMessage({ id: deleteButton })}
          </button>
          <button
            onClick={onCancel}
            type="button"
            className="ml-3 btn btn-bordered d-flex align-items-center"
            style={{ color: '#58595B', height: HEIGHT }}
          >
            {intl.formatMessage({ id: 'CANCEL' })}
          </button>
        </div>
      </div>
    </Dialog>
  );
}

export default injectIntl(RemoveDialog);
